import { cn } from '../../lib/utils'
import type { ConfidenceLabel } from '../../types/story'

const CONFIDENCE_STYLES: Record<ConfidenceLabel, string> = {
  established:
    'bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-500/20',
  corroborated:
    'bg-sky-500/10 text-sky-700 dark:text-sky-300 border-sky-500/20',
  reported:
    'bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-500/20',
  single_source:
    'bg-slate-500/10 text-slate-700 dark:text-slate-300 border-slate-500/20',
  unverified:
    'bg-rose-500/10 text-rose-700 dark:text-rose-300 border-rose-500/20',
}

const CONFIDENCE_LABELS_TEXT: Record<ConfidenceLabel, string> = {
  established: 'Established',
  corroborated: 'Corroborated',
  reported: 'Reported',
  single_source: 'Single-Source',
  unverified: 'Unverified',
}

interface ConfidenceBadgeProps {
  label: ConfidenceLabel
  className?: string
}

export function ConfidenceBadge({ label, className }: ConfidenceBadgeProps) {
  const text = CONFIDENCE_LABELS_TEXT[label]
  return (
    <span
      role="status"
      aria-label={`Confidence: ${text}`}
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium',
        CONFIDENCE_STYLES[label],
        className,
      )}
    >
      {text}
    </span>
  )
}
